import "./Cart.module.css";
import Header from "@/reusable_sections/Header";
import CartContent from "./sections/CartContent";
export default function CartPage() {
  return <div>
      <Header />
      <CartContent />
    </div>;
}